/**Toast Const */
import { ToastComponent } from '../../../../common/toast.component';
/*Const File */
import { apiCalls, checkoutFields, displayValues, proJobConst, requestedWorkPage, site, spekwo, spekwoType, toastMsg, toolTip } from '../../../../utils';
/*Service File*/
import { SolutionFormService } from '../../../solutionForm/solutionForm.service';
import { EcommerceOrdersService } from '../../orders.service';
import { CommonOrdersService } from '../../commonOrders.service';
/*Pop up Component*/
import { MaterialsPopUpComponent } from '../materials-pop-up/materials-pop-up.component';
import { PreListPopUpComponent } from '../pre-list-pop-up/pre-list-pop-up.component';
/* Angular Materials*/
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FuseConfirmDialogComponent } from '../../../../../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-pro-job-details',
  templateUrl: './pro-job-details.component.html',
  styleUrls: ['./pro-job-details.component.scss']
})
export class ProJobDetailsComponent implements OnInit {
  orderValues = displayValues;
  proJobConst = proJobConst;
  toastMsg = toastMsg;
  site = site;
  toolTip = toolTip;
  apiCalls = apiCalls;
  requestedWorkPage = requestedWorkPage;
  spekwoType = spekwoType;
  checkoutFields = checkoutFields;
  spekwoValues = spekwo;

  displayedColumns = ['ID', 'DESCRIPTION', 'SOLUTION', 'PICTURES', 'SHOPPING MATERIAL', 'SUPPLIES MATERIAL'];
  shoppingList: any = [];
  suppliesList: any = [];
  pageSize: number = 10;
  currentOrderId: number;
  acceptedReports: any[] = [];
  toggleSolutionTotalCost: number = 0;
  isLoading: boolean = false;
  imagesData: imageList[] = [];
  quoteImage: any[] = [];
  signImage: string = '';

  proJobDataSource: MatTableDataSource<proJobProperty>;
  @ViewChild(MatPaginator) proJobDataPaginator: MatPaginator;

  insReportIdChangeSubscription: Subscription;
  orderTypeChangeSubscription: Subscription;
  buyerPropertyChangesSubscription: Subscription;
  clientNameSubscription: Subscription;
  clientRoleChangeSubscription: Subscription;

  orderType: string;
  insReportId: string;
  buyerProperty: string;
  clientName: string;
  agent: string;

  orderDetails: any = {
    fullName: '',
    email: '',
    mobileNumber: '',
    city: '',
    state: '',
    pincode: '',
    propertyAddress: '',
    metaData: '',
    itemsNumber: '',
    quoteImage: [],
    signImage: '',
    proSolution :'',
    descIssue : '',
    costToclient:0,
    signDate:'',
    statusId:''
  };

  data: any;
  isPreList: boolean = true;
  isSpecficItemSpekwo: boolean = false;

  // pdf
  isOrderHasAttachment: boolean = false;
  currentOrderAttachLink: any;
  ocrDocumentUrl: any;
  private _subscriptions: Subscription[] = [];
  nodeId: any;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  allStatus: OrderStatus[];
  constructor(
    /**Service File */
    private solutionFormService: SolutionFormService,
    public commonOrdersService: CommonOrdersService,
    public ecommerceOrdersService: EcommerceOrdersService,
    /** Route */
    public route: ActivatedRoute,
    /** Dialog*/
    private dialog: MatDialog,
    /** Toast */
    public toastComponent: ToastComponent,
  ) { }

  ngOnInit() {
    this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
      this.allStatus = statusRes.length > 0 ? statusRes : [];
    });
    // get current order from params
    this.route.params.subscribe(params => {
      this.currentOrderId = params.id;
    });
    /**Inspection id  */
    this.insReportIdChangeSubscription =
      this.solutionFormService.insReportIdChange.subscribe(insRes => {
        this.insReportId = insRes && insRes.insReportId;
      });
    /**Order type */
    this.orderTypeChangeSubscription =
      this.solutionFormService.orderTypeChange.subscribe(typeRes => {
        this.orderType = typeRes;
      })
    /**Buyer property */

    this.buyerPropertyChangesSubscription =
      this.solutionFormService.buyerPropertyChanges.subscribe(propertyRes => {
        this.buyerProperty = propertyRes;
      })

    /**Client  Name -not billing name .Its separate field */
    this.clientNameSubscription =
      this.solutionFormService.clientNameChange.subscribe(data => {
        if (data != undefined) {
          this.clientName = data && data.name;
        }
      })

    //Pdf final file link.
    this._subscriptions.push(this.ecommerceOrdersService.currentOrderPdfFinalLink.subscribe(res => {

      if (!res.loading) {
        this.isOrderHasAttachment = res.data.isOrderHasAttachment;
        this.currentOrderAttachLink = res.data.currentOrderAttachLink;
      } else {
        this.isOrderHasAttachment = false;
        this.currentOrderAttachLink = '';
      }
    }));

    //pdf
    this._subscriptions.push(
      this.solutionFormService.ocrDocumentChange.subscribe(res => {
        if (!res.loading) {
          this.ocrDocumentUrl = res.data;
        }
      })
    );

    this.getToggleSolution(this.currentOrderId);

    //order
    this.orderInfo();

    //Get Quote Images And SIgn Images
    this.getScheduleInfo();

  }
  getScheduleInfo() {
    this.solutionFormService.checkOrderStatus(this.currentOrderId).then((imagesRes: any) => {
      let scheduleData = imagesRes && imagesRes.length > 0 && imagesRes[0].node ? imagesRes[0].node : [];
      this.orderDetails.quoteImage = scheduleData.quoteImages ? scheduleData.quoteImages : [];
      this.orderDetails.signImage = scheduleData.signImages ? scheduleData.signImages : '';
      this.orderDetails.proSolution = scheduleData.proSolution ? scheduleData.proSolution : '';
      this.orderDetails.descIssue = scheduleData.descIssue ? scheduleData.descIssue : '';
      this.orderDetails.costToClient = scheduleData.costToClient ? scheduleData.costToClient : '';
      this.orderDetails.signDate = scheduleData.statusChangeAt ? scheduleData.statusChangeAt : '';
      this.nodeId = scheduleData.nodeId ? scheduleData.nodeId : '';
      this.orderDetails.statusId = scheduleData.statusId ? scheduleData.statusId : '';
    }).catch((err) => {
      console.log("Error in Get Images from Schedule Request", err);
      this.orderDetails.quoteImage = [];
      this.orderDetails.signImage = '';
    });
  }
  orderInfo() {
    this.commonOrdersService.getOrderByOrderId(this.currentOrderId).then((response: any) => {

      let data = response && response.data && response.data.allOrders && response.data.allOrders.nodes.length > 0 && response.data.allOrders.nodes[0] && response.data.allOrders.nodes[0].orderContent ? response.data.allOrders.nodes[0].orderContent : null;
      if (data) {
        let orderContent = JSON.parse(data);
        this.data = orderContent ? orderContent : '';
        var billing = orderContent.billing;
        this.orderDetails.fullName = orderContent && billing && billing.first_name ? billing.first_name + ' ' + billing.last_name : '';
        this.orderDetails.email = orderContent && billing && billing.email ? billing.email : '';
        this.orderDetails.mobileNumber = orderContent && billing && billing.phone ? billing.phone : '';
        this.orderDetails.city = orderContent && billing && billing.city ? billing.city : '';
        this.orderDetails.state = orderContent && billing && billing.state ? billing.state : '';
        this.orderDetails.pincode = orderContent && billing && billing.postcode ? billing.postcode : '';

        if (orderContent && orderContent.meta_data && orderContent.meta_data.length > 0) {
          let buyerProperty = orderContent.meta_data.filter(data => {
            return data.key === this.checkoutFields.buyerProperty
          });
          let items = orderContent.meta_data.filter(data => {
            return data.key === this.checkoutFields.itemList
          });
          this.orderDetails.propertyAddress = buyerProperty && buyerProperty.length > 0 && buyerProperty[0].value ? buyerProperty[0].value : '';
          this.orderDetails.itemsNumber = items && items.length > 0 && items[0].value ? items[0].value : '';
          this.orderDetails.metaData = orderContent.meta_data;
        }
        if (this.orderType == this.spekwoValues.RJCZPSJ) {
          this.isPreList = false;
        }
        if (this.orderType == this.spekwoValues.CGPYWCK) {
          this.isSpecficItemSpekwo = true;
        }
      }
    }).catch((err) => {
      console.log("error in get order by OrderId", err);
    });
  }
  getToggleSolution(orderId) {
    this.isLoading = true;
    this.acceptedReports = [];
    this.toggleSolutionTotalCost = 0;
    if (orderId != undefined) {
      this.solutionFormService.getClientAcceptedSolution(orderId).then((response: any) => {
        if (response && response.masterResponse) {
          response.masterResponse.forEach((res, key) => {
            let acceptedResponse = res && res.node && res.node.reportReviewDetailByReviewId ? res.node.reportReviewDetailByReviewId : null;
            let uploadedPics = acceptedResponse && acceptedResponse.beforeAndAfterRepairPicturesByReviewId && acceptedResponse.beforeAndAfterRepairPicturesByReviewId
              && acceptedResponse.beforeAndAfterRepairPicturesByReviewId.nodes && acceptedResponse.beforeAndAfterRepairPicturesByReviewId.nodes.length > 0
              && acceptedResponse.beforeAndAfterRepairPicturesByReviewId.nodes[0].beforeRepair && acceptedResponse.beforeAndAfterRepairPicturesByReviewId.nodes[0].beforeRepair.length > 0 ?
              acceptedResponse.beforeAndAfterRepairPicturesByReviewId.nodes[0].beforeRepair : []
            this.acceptedReports.push({
              uploadedPics: uploadedPics,
              reviewId: acceptedResponse.reviewId,
              name: acceptedResponse.subCategoryName ? acceptedResponse.categoryName ? acceptedResponse.categoryName + ':' + acceptedResponse.subCategoryName : acceptedResponse.subCategoryName : acceptedResponse.categoryName,
              description: acceptedResponse.description,
              totalCost: acceptedResponse.totalCost,
              solution: acceptedResponse.solution,
              id: acceptedResponse.id,
              costOption: acceptedResponse.costOption,
              reviewNodeId: acceptedResponse.nodeId,
              ni: acceptedResponse.ni,
              cpi: acceptedResponse.cpi,
              cpf: acceptedResponse.cpf,
              tf: acceptedResponse.tf,
              hourRate: acceptedResponse.hourRate,
              laborHour: acceptedResponse.laborHour,
              labourCost: acceptedResponse.labourCost,
              materialCost: acceptedResponse.materialCost,
              categoryName: acceptedResponse.categoryName,
              shoppingList: acceptedResponse.shoppingMaterials,
              suppliesList: acceptedResponse.materialList,
            });
            //calculating total cost
            this.toggleSolutionTotalCost = Number(this.toggleSolutionTotalCost) + Number(res.node.reportReviewDetailByReviewId.totalCost);
          });
          this.proJobDataSource = new MatTableDataSource(this.acceptedReports);
          this.proJobDataSource.paginator = this.proJobDataPaginator;
          this.isLoading = false;
        }
      }).catch(err => {
        console.log(err);
        this.acceptedReports = [];
      });
    }
  }
  openShoppingList(solution) {
    this.shoppingList = solution.shoppingList && solution.shoppingList.length > 0 ? solution.shoppingList : [];
    if (this.shoppingList.length > 0) {
      this.dialog.open(MaterialsPopUpComponent,
        {
          width: 'calc(100% - 50%)',
          height: 'calc(100% - 50%)',
          data: {
            title: this.proJobConst.tableColumn.shoppingMaterial,
            materialList: this.shoppingList,
            uploadedPics: [],
          },
        });
    }
    else {
      this.toastComponent.showToast(this.toastMsg.noShoppingMaterialList);
    }
  }
  openSuppliesList(solution) {
    this.suppliesList = solution.suppliesList && solution.suppliesList.length > 0 ? solution.suppliesList : [];
    if (this.suppliesList.length > 0) {
      this.dialog.open(MaterialsPopUpComponent,
        {
          width: 'calc(100% - 50%)',
          height: 'calc(100% - 50%)',
          data: {
            title: this.proJobConst.tableColumn.suppliesMaterial,
            materialList: this.suppliesList,
            uploadedPics: [],
          },
        });
    }
    else {
      this.toastComponent.showToast(this.toastMsg.noSuppliesMaterialList);
    }

  }
  openUploadedPics(solution) {
    this.imagesData = [];
    solution.uploadedPics.forEach((pics, key) => {
      this.imagesData.push({ image: site.apiHost + pics, thumbImage: site.apiHost + pics })
    });

    if (this.imagesData.length > 0) {
      this.dialog.open(MaterialsPopUpComponent,
        {
          width: 'calc(100% - 10%)',
          height: 'calc(100% - 47%)',
          data: {
            title: this.proJobConst.tableColumn.uploadedPics,
            uploadedPics: this.imagesData,
            materialList: [],
          },
        });
    }
    else {
      this.toastComponent.showToast(this.toastMsg.noUploadPicsList);
    }

  }
  preListPictures() {
    this.dialog.open(PreListPopUpComponent,
      {
        data: {
          orderId: this.currentOrderId,
        },
        width: '100%',
        height: '85%',
      });
  }
  viewSignImages() {
    this.imagesData = [];
    if (this.orderDetails.signImage.length > 0) {
      this.imagesData.push({ image: site.apiHost + this.orderDetails.signImage, thumbImage: site.apiHost + this.orderDetails.signImage })
      this.dialog.open(MaterialsPopUpComponent,
        {
          width: 'calc(100% - 10%)',
          height: 'calc(100% - 47%)',
          data: {
            title: this.proJobConst.tableColumn.uploadedPics,
            uploadedPics: this.imagesData,
            materialList: [],
          },
        });
    }
    else {
      this.toastComponent.showToast(this.toastMsg.noSignImageList);
    }
  }
  viewQuoteImages() {
    this.imagesData = [];
    if (this.orderDetails.quoteImage.length > 0) {
      this.orderDetails.quoteImage.forEach((pics) => {
        this.imagesData.push({ image: site.apiHost + pics, thumbImage: site.apiHost + pics })
      });

      this.dialog.open(MaterialsPopUpComponent,
        {
          width: 'calc(100% - 10%)',
          height: 'calc(100% - 47%)',
          data: {
            title: this.proJobConst.tableColumn.uploadedPics,
            uploadedPics: this.imagesData,
            materialList: [],
          },
        });
    }
    else {
      this.toastComponent.showToast(this.toastMsg.noQuoteImageList);
    }
  }
  homeInspection() {

    if (this.isOrderHasAttachment) {
      window.open(this.currentOrderAttachLink, '_blank');
    }
    else if (this.ocrDocumentUrl && this.ocrDocumentUrl.message.length > 0) {
      var url = this.apiCalls.ocrDocumentUrl + '/' + this.currentOrderId + '/' + this.ocrDocumentUrl.message[0];
      window.open(url, '_blank');
    }
    else if (!this.isOrderHasAttachment && !(this.ocrDocumentUrl && this.ocrDocumentUrl.message.length > 0)) {
      if (this.orderDetails.metaData.length > 0 && this.orderDetails.metaData) {
        let checkHomeInspection = this.orderDetails.metaData.filter(data => {
          return data.key === this.checkoutFields.homeInspectionReport
        });
        let url = checkHomeInspection && checkHomeInspection.length > 0 && checkHomeInspection[0].value ? checkHomeInspection[0].value : null;
        if (url) {
          window.open(url, '_blank');
        }
        else {
          this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
        }
      }
      else {
        this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
      }
    }
    else {
      this.toastComponent.showToast(this.toastMsg.noDocumentUploaded);
    }

  }
  closeProject(){
    if( this.orderDetails.statusId == this.allStatus[5].statusId){
      this.toastComponent.showToast(this.toastMsg.alreadyClosed);
    }
    else{
      this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
        disableClose: false
      });
      this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.closeProjecttMessage;
      this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
      this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
      this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;
      this.confirmDialogRef.afterClosed().subscribe(result => {
        if(result && this.nodeId){
          this.ecommerceOrdersService.closeProjectByAdmin(this.nodeId).then((closeRes)=>{
              this.toastComponent.showToast(this.toastMsg.closeProjectSuccess);
          }).catch(() =>{
            this.toastComponent.showToast(this.toastMsg.closeProjectFiled);

          });
        }
      });
    }
  }

}
export interface proJobProperty {
  id: number,
  description: string,
}

export interface imageList {
  image: string,
  thumbImage: string,
}

export interface OrderStatus {
  statusId: number;
  statusName: string;
  displayStatus: string;
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/pro-job-details/pro-job-details.component.ts